import styled from "styled-components";
import colors from "../../constants/colors";

export const CustomerContentWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "0.25rem",
});

export const CustomerInfo = styled("span")({
  fontSize: "0.8125rem",
  fontWeight: 600,
  color: colors.BLACK,
  lineHeight: 1.2,
});

export const BookingInfo = styled("span")({
  fontSize: "0.75rem",
  fontWeight: 500,
  color: colors.GREY_7,
  lineHeight: 1.2,
});
